import { render, staticRenderFns } from "./AgreementHistory.html?vue&type=template&id=b3139fa8&"
import script from "./AgreementHistory.component.js?vue&type=script&lang=js&"
export * from "./AgreementHistory.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports